export const DEFAULT_ORG_ID = "org_default";
const NIA_BRANDED_ORG_IDS = new Set([DEFAULT_ORG_ID, "org_shuttle"]);

const NIA_BRAND_ASSETS = {
  logo: {
    light: "/brand/nia/logo-light.svg",
    dark: "/brand/nia/logo-dark.svg",
  },
  wordmark: {
    light: "/brand/nia/wordmark-light.svg",
    dark: "/brand/nia/wordmark-dark.svg",
  },
  icon: {
    light: "/icons/nia/logo-icon-light.svg",
    dark: "/icons/nia/logo-icon-dark.svg",
  },
  splash: {
    light: {
      png: "/brand/nia/splash-light.png",
      svg: "/brand/nia/splash-light.svg",
    },
    dark: {
      png: "/brand/nia/splash-dark.png",
      svg: "/brand/nia/splash-dark.svg",
    },
  },
  splashLandscape: {
    light: {
      png: "/brand/nia/splash-landscape-light.png",
      svg: "/brand/nia/splash-landscape-light.svg",
    },
    dark: {
      png: "/brand/nia/splash-landscape-dark.png",
      svg: "/brand/nia/splash-landscape-dark.svg",
    },
  },
  hero: {
    light: "/brand/nia/ui/hero-light.svg",
    dark: "/brand/nia/ui/hero-dark.svg",
  },
};

function normalizeMode(mode = "light") {
  return mode === "dark" ? "dark" : "light";
}

export function getNiaBrandAsset(kind = "logo", mode = "light") {
  const safeMode = normalizeMode(mode);
  const asset = NIA_BRAND_ASSETS[kind]?.[safeMode];
  if (asset && typeof asset === "object") return asset.png || asset.svg || "";
  return asset || NIA_BRAND_ASSETS.logo[safeMode];
}

export function getOrgBrandAssets(orgId, mode = "light", logoUrl = "", logoDarkUrl = "") {
  const safeMode = normalizeMode(mode);
  const splashMode = NIA_BRAND_ASSETS.splash[safeMode] || {};
  const splashLandscapeMode = NIA_BRAND_ASSETS.splashLandscape[safeMode] || {};
  const platformSplash = {
    splashUrl: splashMode.png || splashMode.svg || "",
    splashFallbackUrl: splashMode.svg || splashMode.png || "",
    splashLandscapeUrl: splashLandscapeMode.png || splashLandscapeMode.svg || "",
    splashLandscapeFallbackUrl: splashLandscapeMode.svg || splashLandscapeMode.png || "",
    splashLight: NIA_BRAND_ASSETS.splash.light.png,
    splashDark: NIA_BRAND_ASSETS.splash.dark.png,
    splashLandscapeLight: NIA_BRAND_ASSETS.splashLandscape.light.png,
    splashLandscapeDark: NIA_BRAND_ASSETS.splashLandscape.dark.png,
  };

  if (NIA_BRANDED_ORG_IDS.has(orgId)) {
    return {
      logoUrl: getNiaBrandAsset("logo", safeMode),
      wordmarkUrl: getNiaBrandAsset("wordmark", safeMode),
      iconUrl: getNiaBrandAsset("icon", safeMode),
      ...platformSplash,
      heroUrl: getNiaBrandAsset("hero", safeMode),
    };
  }
  const resolvedLogo = safeMode === "dark"
    ? (logoDarkUrl || logoUrl || getNiaBrandAsset("logo", safeMode))
    : (logoUrl || logoDarkUrl || getNiaBrandAsset("logo", safeMode));
  return {
    logoUrl: resolvedLogo,
    wordmarkUrl: resolvedLogo || getNiaBrandAsset("wordmark", safeMode),
    iconUrl: resolvedLogo || getNiaBrandAsset("icon", safeMode),
    ...platformSplash,
    heroUrl: "",
  };
}

export function getOrgLogoAsset({ orgId, logoUrl, logoDarkUrl, mode = "light", compact = false, kind = "logo" } = {}) {
  const assets = getOrgBrandAssets(orgId, mode, logoUrl, logoDarkUrl);
  if (compact) return assets.iconUrl;
  if (kind === "wordmark") return assets.wordmarkUrl;
  return assets.logoUrl;
}
